import { getConsentId } from './model/get-consent-id'
import { ConsentProviderPort } from '../ports'
import { cookie } from '@otto-ec/global-resources/cookie'
import { ConsentTtlService } from './optanon-consent-ttl/consent-ttl.service'
import { LoggingServicePort } from '@otto-ec/eprivacy-shared'
import { OneTrust } from './model/onetrust'

export class LazyOnetrustConsentProvider implements ConsentProviderPort {
  private oneTrust: OneTrust | undefined
  private isInitializing = false
  private onConsentChanged: () => void = () => {
    /*    */
  }

  constructor(
    private readonly oneTrustFn: () => Promise<OneTrust>,
    private readonly consentTtlService: ConsentTtlService,
    private readonly logger: LoggingServicePort
  ) {
    if (this.checkConsentCookie()) {
      this.logger.info(
        'Consent has already been given, no need to initialize OneTrust again.'
      )
      /*                                                                                 */
      Object.defineProperty(window, 'OneTrust', {
        get: () => {
          if (this.isInitializing) {
            return undefined
          }
          this.isInitializing = true
          this.logger.info(
            'Initializing OneTrust because window.OneTrust was called.'
          )
          void this.initializeOneTrust()
          return undefined
        },
        set: (value: OneTrust) => {
          /*                                                                                         */
          Object.defineProperty(window, 'OneTrust', {
            value,
          })
          this.isInitializing = false
        },
        configurable: true,
      })
    } else {
      void this.initializeOneTrust()
      this.isInitializing = true
    }
  }

  private checkConsentCookie(): boolean {
    /*                                               */
    return cookie.exists('OptanonAlertBoxClosed')
  }

  private async initializeOneTrust(): Promise<void> {
    this.oneTrust = await this.oneTrustFn()
    this.oneTrust.OnConsentChanged(this.onConsentChanged)
  }

  OnConsentChanged(callback: () => void): void {
    this.onConsentChanged = () => callback()
    if (this.oneTrust) {
      this.oneTrust.OnConsentChanged(this.onConsentChanged)
    }
  }

  hasConsentBeenGiven(): boolean {
    /*                               */
    if (this.checkConsentCookie()) {
      return true
    }

    /*                                                            */
    if (this.oneTrust) {
      return this.oneTrust.IsAlertBoxClosedAndValid()
    }

    /*                                                             */
    return false
  }

  getConsentId(): null | string {
    return getConsentId()
  }

  getConsentTtl(): Promise<number | undefined> {
    return this.consentTtlService.getConsentTtl()
  }
}
